var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"welcome"},_vm._l((_vm.stamps),function(data,index){return _c('IndexBlock',{key:index,staticClass:"welcome__block",style:({
      pointerEvents: data.comingsoon ? 'none' : false,
    }),attrs:{"data":data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }